/**
 * Who a user should call when they cannot sign in, or when a session ends in a
 * way they did not expect.
 *
 * One definition, because the contact now appears on the login page and in the
 * session-ended dialog. The display form and the `tel:` form are separate
 * fields on purpose: the dialler form must have no spaces, and keeping them
 * side by side here is what stops someone updating the visible number while
 * leaving the link pointing at the old one.
 *
 * Not read from `config.json` today because every deployment shares this
 * contact. If that stops being true, mirror the `timings.ts` pattern — a
 * default here, overridden by ConfigProvider at startup — rather than editing
 * this file per site.
 */
export const SUPPORT_CONTACT = {
  name: "Brian Ng",
  /** As shown to the user. */
  phone: "2885 2038",
  /** For `tel:` links — digits only. */
  tel: "28852038",
  /** For `mailto:` links, and shown as-is. */
  email: "brian.ng@plshki.com",
};
